import { DateField, ReferenceField, Show, SimpleShowLayout, TextField } from 'react-admin';

export const FinancialReserveShow: React.FC = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField label="ID" source="id" />
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
        <TextField label="Forma finančnej rezervy" source="text" />
        <TextField label="Suma" source="amount.amount" />
        <DateField label="Dátum vytvorenia" locales="sk" showTime={true} source="creationTimestamp" />
        <DateField label="Dátum zmeny" locales="sk" showTime={true} source="updateTimestamp" />
      </SimpleShowLayout>
    </Show>
  );
};
